import { Component, OnInit } from '@angular/core';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderService } from '../../services/cardholder.service';
import { Identity } from '../../Identity';
import { CustomerAccount } from '../../data/CustomerAccount';
import { Transaction } from '../../data/Transaction';
import { ExpandedTransaction } from '../../data/ExpandedTransaction';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CardholderDetails } from '../../data/CardholderDetails';
import { TransactionInfo } from '../../data/TransactionInfo';
import { MessageService } from '../../services/message.service';
import {Card} from "../../data/Card";

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  cardholder: ProfileSearchResult;
  cardholderDetails: CardholderDetails;
  identity: Identity;
  acctFilter = '0';
  showAllTrans = true;
  customerAccounts: CustomerAccount[] = [];
  transLoading = false;
  expanded = false;
  dbTransactions: ExpandedTransaction[] = [];
  unfilteredTransactions: ExpandedTransaction[] = [];
  payrollAccount: number;
  isEscrow = false;
  startDate: NgbDate;
  endDate: NgbDate;
  chipsAccount: CustomerAccount[];
  applyReverseButtonSpinnerString = '';
  chipOnly: boolean;
  cardsAccount: Card[];

  constructor(
    private calendar: NgbCalendar,
    private entitlementService: EntitlementService,
    private cardHolderService: CardholderService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    this.loadPageData();
  }

  loadPageData() {
    this.endDate = this.calendar.getToday();
    this.startDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - 90);
    this.payrollAccount = this.cardholder.payrollAccount;
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      1
    );
    this.cardHolderService.getCardholderDetails(this.payrollAccount).subscribe(
      (data) => {
        this.cardholderDetails = data;
        this.cardsAccount = data.cardList;
        this.chipsAccount = data.customerAccounts.slice(
          1,
          data.customerAccounts.length
        );
        this.loadTransactionHistory();
      },
      (error) => {
        this.messageService.error('Error finding card holder details: ' + error);
      },
      () => {
        this.checkChipOnly();
        this.cardHolderService.chipDetails(this.chipOnly);
      }
    );
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
    this.loadPageData();
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  trackByTransSeq(index: number, transaction: ExpandedTransaction): number {
    return transaction.tran.tranSequence;
  }

  showDetails(expandedTrans: ExpandedTransaction) {
    expandedTrans.c2cDetails = '';
    let details: string[];
    const tranDetails = {};
    details = expandedTrans.tran.typeDescription.split('\n');

    for (let x = 0; x < details.length; x += 2) {
      tranDetails[details[x]] = details[x + 1];
    }

    if (
      expandedTrans.tran.merchantName !== null &&
      expandedTrans.tran.merchantName.trim() !== ''
    ) {
      tranDetails['Merchant:'] = expandedTrans.tran.merchantName;
    }

    if (
      expandedTrans.tran.type === '0061' ||
      expandedTrans.tran.type === '0260' ||
      expandedTrans.tran.type === '0331' ||
      expandedTrans.tran.type === '0334'
    ) {
      this.cardHolderService
        .getC2CDetails(
          this.cardholder.payrollAccount,
          expandedTrans.tran.tranSequence,
          expandedTrans.tran.type
        )
        .subscribe(
          (data: Transaction) => {
            expandedTrans.c2cDetails = data.typeDescription;
          },
          () => {
            expandedTrans.c2cDetails = '';
          }
        );
    }
    expandedTrans.tranDetails = tranDetails;
  }

  reverse(transaction: Transaction) {
    this.transLoading = true;
    const that = this;
    this.cardHolderService.reverse(transaction.tranSequence).subscribe(
      () => {
        transaction.reverseState = -1;
        that.loadTransactionHistory();
        this.messageService.success('Reversal Successful');
      },
      (error) => {
        that.messageService.error(error.data);
      }
    );
  }

  loadTransactionHistory() {
    this.dbTransactions = [];
    this.unfilteredTransactions = [];
    const startDateString =
      this.startDate.month +
      '/' +
      this.startDate.day +
      '/' +
      this.startDate.year;
    const endDateString =
      this.endDate.month + '/' + this.endDate.day + '/' + this.endDate.year;
    this.chipsAccount.forEach((chipAccount: CustomerAccount) => {
      this.transLoading = true;
      this.cardHolderService
        .getTransHistory(
          this.payrollAccount,
          chipAccount.account,
          startDateString,
          endDateString
        )
        .subscribe(
          (data: TransactionInfo) => {
            console.log(
              'Returned the following transactions count: ' +
                data.transactions.length
            );
            this.isEscrow = data.isEscrow;
            data.transactions.forEach((trans: Transaction) => {
              const tempExpTran = <ExpandedTransaction>{};
              tempExpTran.tran = trans;
              this.unfilteredTransactions.push(tempExpTran);
            });
            this.filterTransactions();
            this.transLoading = false;
          },
          () => {
            this.transLoading = false;
          }
        );
    });
  }

  filterTransactions() {
    const keys = [];
    this.dbTransactions = [];
    this.showAllTrans = this.acctFilter === '0';
    this.unfilteredTransactions.forEach((tran: ExpandedTransaction) => {
      if ('' + tran.tran.account === this.acctFilter || this.showAllTrans) {
        const key = tran.tran.tranSequence;
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          this.dbTransactions.push(tran);
          this.dbTransactions.sort((objA, objB) => 
            new Date(objB.tran.postDate).getTime() - new Date(objA.tran.postDate).getTime()
          );
        }
      }
    });
  }

  checkChipOnly() {
    const index = this.cardsAccount.findIndex(x => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }
}
